<template>
	<div>
		<div class="banner">
			<img src="../../assets/images/home/banner.png" style="width: 100%;height: 706px;" />
			<div class="flex flex-b tools">
				<div class="flex tool pointer" @click="toPage('/course')">
					<img src="../../assets/images/home/homeIc1.png" style="width: 59px;height: 58px;" />
					<div>
						<div class="tit1">在线课程</div>
						<div class="tit2">更多在线课程</div>
					</div>
				</div>
				<div class="flex tool pointer" @click="toPage('/training')">
					<img src="../../assets/images/home/homeIc2.png" style="width: 59px;height: 58px;" />
					<div>
						<div class="tit1">线下培训</div>
						<div class="tit2">更多在线课程</div>
					</div>
				</div>
				<div class="flex tool pointer" @click="toPage('/about')">
					<img src="../../assets/images/home/homeIc3.png" style="width: 59px;height: 58px;" />
					<div>
						<div class="tit1">关于S学苑</div>
						<div class="tit2">这里是一句话的介绍</div>
					</div>
				</div>
				<div class="flex tool pointer" @click="toPage('/telenology')">
					<img src="../../assets/images/home/homeIc4.png" style="width: 59px;height: 58px;" />
					<div>
						<div class="tit1">核心技术</div>
						<div class="tit2">这里是一句话的介绍</div>
					</div>
				</div>
			</div>
		</div>
		<div class="constants">
			<div class="topimg">
				<img src="../../assets/images/home/zhuangshi.png" style="width: 100%;height: 67px;" />
				<div class="toptexts flex flex-c pointer" @click="$router.push('/course?is_hot='+true)">
					<div class="flex">
						<div class="title">热点课程</div>
						<img src="../../assets/images/home/arrow_r.png"
							style="width: 13px;height: 13px;margin-left: 7px;" />
					</div>
					<div class="subtitle">根据平台热门内容</div>
				</div>
			</div>
			<div class="hotbg flex flex-b" v-if="hotList.length>0">
				<div class="itembg pointer" v-for="(item,index) in hotList" @click="toCourseDetail(item)">
					<img :src="item.img" style="width: 100%;height: 163px;border-radius: 13px;" />
					<div class="ititle">{{item.name}}</div>
					<div class="flex">
						<div class="flag flex flex-c">{{item.course_cate_name}}</div>
					</div>
					<div class="flex flex-b" style="margin-top: 16px;">
						<div class="price flex">{{item.score}}
							<div class="span">积分</div>
						</div>
						<!-- <div class="ygm">2,156人已购买</div> -->
					</div>
				</div>
				<div class="itembg pointer" style="background: transparent;" v-for="item in (4 - hotList.length % 4) % 4">
				</div>
			</div>
			<div class="flex flex-c flex-column-item flex-c-c nodata hotbg" v-else>
				<img src="../../assets/images/mine/ico5.png" style="width: 38px;height: auto;margin-bottom: 10px;" />
				暂无内容
			</div>

			<div class="flex flex-c-c" style="margin: 40px 0 31px 0;">
				<img src="../../assets/images/home/ic_right.png" class="pointer" @click="clickQualityCourseIndex(-1)"
					style="width: 33px;height: 33px;" />
				<div class="onTitle">
					精品课程
				</div>
				<img src="../../assets/images/home/ic_left.png" @click="clickQualityCourseIndex(1)" class="pointer"
					style="width: 33px;height: 33px;" />
			</div>

			<div class="flex flex-b flex-wrap" v-if="qualityList.length!=0" style="padding: 0 133px;">
				<div class="itembg1 pointer" v-for="item in qualityList" @click="toCourseDetail(item)">
					<img :src="item.img" style="width: 100%;height: 205px;border-radius: 13px;" />
					<div class="ititle">{{item.name}}</div>
					<div class="flex flex-b">
						<div class="flag flex flex-c">{{item.course_cate_name}}</div>
						<div class="flag1">{{item.sub_course_cate_name}}</div>
					</div>
					<div class="flex flex-b" style="margin-top: 24px;">
						<div class="price flex">{{item.score}}
							<div class="span">积分</div>
						</div>

					</div>
				</div>
				<div class="itembg1 pointer" style="box-shadow: none;" v-for="item in (3-tarinList.length%3)"></div>
			</div>

			<div class="flex flex-c flex-column-item flex-c-c nodata hotbg" v-else>
				<img src="../../assets/images/mine/ico5.png" style="width: 38px;height: auto;margin-bottom: 10px;" />
				暂无内容
			</div>

			<div class="flex flex-c">
				<div class="moreBtn flex flex-c-c flex-c pointer" @click="$router.push('/course')">
					<div class="tex">更多课程</div>
					<img src="../../assets/images/home/rightGreen.png" style="width: 7px;height: 9px;margin-left: 7px;">
				</div>
			</div>
			<div class="flex flex-c-c" style="margin: 40px 0 31px 0;">
				<img src="../../assets/images/home/ic_right.png" @click="clickTrainIndex(-1)" class="pointer"
					style="width: 33px;height: 33px;" />
				<div class="onTitle">
					热门培训
				</div>
				<img src="../../assets/images/home/ic_left.png" @click="clickTrainIndex(1)" class="pointer"
					style="width: 33px;height: 33px;" />
			</div>

			<div class="flex flex-b flex-wrap" v-if="tarinList.length!=0" style="padding: 0 133px;">
				<div class="itembg1 pointer" v-for="item in tarinList" @click="toTarinDetail(item)">
					<img :src="item.img" style="width: 100%;height: 205px;border-radius: 13px;" />
					<div class="ititle">{{item.name}}</div>
					<div style="margin-top: 13px;" class="flex">
						<img src="../../assets/images/home/ic_calendar.png"
							style="width: 13px;height: 13px;margin-right: 7px;" />
						<div class="addItem">{{item.begin_time}} 至 {{item.end_time}}</div>
					</div>
					<div style="margin-top: 13px;" class="flex">
						<img src="../../assets/images/home/ic_address.png"
							style="width: 13px;height: 13px;margin-right: 7px;" />
						<div class="addItem">{{item.address}}</div>
					</div>
					<div class="flex flex-b" style="margin-top: 24px;">
						<div class="price flex" v-if="item.pay_type==1">¥{{item.price}}
						</div>
						<div class="price flex" v-if="item.pay_type==2">¥{{item.score}}
						</div>
						<div class="price flex" v-if="item.pay_type==3">免费培训
						</div>
						<div class="moreBtn flex flex-c-c flex-c pointer" style="width: 109px;height: 49px;margin: 0;">
							<div class="tex">立即报名</div>
							<img src="../../assets/images/home/rightGreen.png"
								style="width: 7px;height: 9px;margin-left: 7px;">
						</div>
					</div>
				</div>
				<div class="itembg1 pointer" style="box-shadow: none;" v-for="item in (3-tarinList.length%3)"></div>
			</div>

			<div class="flex flex-c flex-column-item flex-c-c nodata hotbg" v-else>
				<img src="../../assets/images/mine/ico5.png" style="width: 38px;height: auto;margin-bottom: 10px;" />
				暂无内容
			</div>

			<div class="flex flex-c">
				<div class="moreBtn pxbtn flex flex-c-c flex-c pointer" @click='$router.push("/training")'>
					<div class="tex">更多培训</div>
					<img src="../../assets/images/home/rightGreen.png" style="width: 7px;height: 9px;margin-left: 7px;">
				</div>
			</div>

			<!-- 分页 -->
			<!-- <Pagination></Pagination> -->
		</div>

		<div class="toTop" v-if="showBackToTop" @click="scrollToTop"></div>

		<!-- 提示框 -->
		<!-- <Toast ref="toastRef"></Toast> -->
	</div>
</template>

<script>
	import {
		getCourse
	} from "@/api/course";
	import {
		getTrainList
	} from "@/api/train";
	import Toast from '../../components/Toast.vue';
	import Pagination from '../../components/Pagination.vue';
	export default {
		components: {
			Toast,
			Pagination
		},
		data() {
			return {
				showBackToTop: false, // 控制按钮的显示
				hotList: [],
				qualityList: [],
				tarinList: [],
				trainIndex: 1,
				trainTotalPage: 0,
				qualityCourseIndex: 1,
				qualityCourseotalPage: 0
			}
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
			this.getCourse()
			this.getQualityCourse()
			this.getTrainList()
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll)
		},
		methods: {
			toTarinDetail(item) {
				this.$router.push({
					path: '/trainingDetail',
					query: {
						id: item.uuid,
						source: 'home'
					}
				})
			},
			toCourseDetail(item) {
				this.$router.push({
					path: '/courseDetail',
					query: {
						id: item.uuid,
						source: 'home'
					}
				})
			},
			clickTrainIndex(e) {
				if (e == 1 && this.trainIndex >= this.trainTotalPage) return
				if (e == -1 && this.trainIndex == 1) return
				if (this.trainIndex >= 1) {
					this.trainIndex += e
					this.getTrainList()
				}
			},
			async getTrainList() {
				const {
					status,
					data
				} = await getTrainList({
					page_index: this.trainIndex,
					page_size: 3,
					is_recommend: 1
				});
				this.tarinList = data.result.data
				this.trainTotalPage = data.result.last_page
			},
			async getCourse() {
				const {
					status,
					data
				} = await getCourse({
					is_hot: 1,
					page_index: 1,
					page_size: 4,
					is_home:1
				});
				this.hotList = data.result.data
			},
			clickQualityCourseIndex(e) {
				if (e == 1 && this.qualityCourseIndex >= this.qualityCourseotalPage) return
				if (e == -1 && this.qualityCourseIndex == 1) return
				if (this.qualityCourseIndex >= 1) {
					this.qualityCourseIndex += e
					this.getQualityCourse()
				}
			},
			async getQualityCourse() {
				const {
					status,
					data
				} = await getCourse({
					is_quality: 1,
					page_index: this.qualityCourseIndex,
					page_size: 3,
					is_home:1
				});
				this.qualityList = data.result.data
				this.qualityCourseotalPage = data.result.last_page
			},
			toPage(path) {
				this.$router.push({
					path: path
				})
			},
			handleScroll() {
				// 当滚动到距离底部100px时显示按钮（可根据需求调整）
				const scrollY = window.scrollY
				const visibleHeight = document.documentElement.clientHeight
				const pageHeight = document.documentElement.scrollHeight
				this.showBackToTop = (scrollY + visibleHeight) > (pageHeight + 1000)
			},
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.banner {
		position: relative;
	}

	.tools {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		bottom: 120px;
		width: 65%;

		.tool {
			width: 23%;
			height: 74px;
			background: #FFFFFF;
			box-shadow: 0px 3 13px 0px rgba(0, 0, 0, 0.06);
			border-radius: 89px 89px 89px 89px;
			padding: 20px;

			.tit1 {
				margin-left: 10px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 500;
				font-size: 18px;
				color: #333333;
			}

			.tit2 {
				margin-left: 10px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #999999;
			}
		}
	}

	.toTop {
		position: fixed;
		right: 190px;
		bottom: 143px;
		background: url('../../assets/images/home/top.png') no-repeat;
		width: 53px;
		height: 53px;
		z-index: 9999;
		background-size: 100% 100%;
		cursor: pointer;
	}

	.constants {
		position: relative;
		margin-top: -85px;

		.topimg {
			position: relative;
			display: flex;
			align-items: center;
			justify-content: center;

			.toptexts {
				position: absolute;

				.title {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 20px;
					color: #000000;
				}

				.subtitle {
					margin-top: 4px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #333333;
				}
			}
		}

		.hotbg {
			width: 100%;
			height: 378px;
			background: #F7F8F9;
			padding: 36px 133px 48px 133px;
			border-radius: 0 0 30px 30px;

			.itembg {
				width: calc(25% - 27px);
				background: #FFFFFF;
				box-shadow: 0px 3 13px 0px rgba(0, 0, 0, 0.06);
				border-radius: 13px 13px 13px 13px;
				padding: 9px 11px;

				.ititle {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 18px;
					color: #000000;
					margin-top: 13px;
					white-space: nowrap;
					text-overflow: ellipsis;
					overflow: hidden;
				}

				.flag {
					margin-top: 9px;
					padding: 0 10px;
					height: 22px;
					background: rgba(0, 167, 60, 0.06);
					border-radius: 4px 4px 4px 4px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #00A73C;
				}

				.price {
					font-family: DINPro, DINPro;
					font-weight: bold;
					font-size: 22px;
					color: #00A73C;

					.span {
						margin-left: 2px;
						font-family: HONOR Sans CN, HONOR Sans CN;
						font-weight: 400;
						font-size: 13px;
						color: #00A73C;
						margin-top: 5px;
					}
				}

				.ygm {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 13px;
					color: #999999;
				}
			}
		}
	}

	.onTitle {
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 600;
		font-size: 20px;
		color: #000000;
		position: relative;
		margin: 0 53px 0 62px;
	}

	.onTitle:before {
		content: '';
		z-index: -1;
		left: 0;
		position: absolute;
		bottom: 3px;
		width: 53px;
		height: 4px;
		background: linear-gradient(141deg, #10B649 0%, #7FDA4C 100%);
		border-radius: 0px 0px 0px 0px;
	}

	.itembg1 {
		width: calc(33% - 27px);
		box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
		background: #FFFFFF;
		border-radius: 13px 13px 13px 13px;
		padding: 9px 11px;
		position: relative;
		margin-bottom: 20px;

		.ititle {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 18px;
			color: #000000;
			margin-top: 13px;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
		}

		.addItem {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: #666666;
		}

		.flag {
			margin-top: 16px;
			padding: 0 10px;
			height: 22px;
			background: rgba(0, 167, 60, 0.06);
			border-radius: 4px 4px 4px 4px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: #00A73C;
		}

		.flag1 {
			margin-top: 16px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: #999999;
		}

		.price {
			font-family: DINPro, DINPro;
			font-weight: bold;
			font-size: 22px;
			color: #00A73C;

			.span {
				margin-left: 2px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #00A73C;
				margin-top: 5px;
			}
		}

		.ygm {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: #999999;
		}
	}

	.moreBtn {
		margin: 36px 0 4px 0;
		background: url('../../assets/images/home/btn_40.png') no-repeat;
		width: 164px;
		height: 50px;
		background-size: 100% 100%;

		.tex {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
			background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}

	.pxbtn {
		background: transparent;
		width: 164px;
		height: 44px;
		border-radius: 13px 13px 13px 13px;
		border: 2px solid rgba(0, 167, 60, 0.24);
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 400;
		font-size: 16px;
		background: linear-gradient(51.355320293479146deg, #10B649 0%, #7FDA4C 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.nodata {
		font-size: 16px;
	}
</style>